/**
 * Sidebar from cmenu.api.get_menu on the ERPNext site.
 * TripPlan screens still load their own doctypes through tripplan.api.
 */
import { reactive } from "vue";

import { call } from "../api/client";

const TRIPPLAN_ROUTES = {
	"TP Package": "/tours",
	"TP Booking": "/bookings",
	Customer: "/customers",
	Supplier: "/suppliers",
	"Sales Invoice": "/invoices",
	"Payment Entry": "/payments",
};

const state = reactive({
	menus: [],
	loading: false,
	loaded: false,
	fromApi: false,
	clientCode: null,
});

let loadPromise = null;

function currentClientCode() {
	return (localStorage.getItem("clientCode") || "").trim().toLowerCase() || null;
}

export function getMenuHref(item) {
	if (!item) return "/";
	if (item.type === "DocType" && item.doctype) {
		return TRIPPLAN_ROUTES[item.doctype] || `/desk/${encodeURIComponent(item.doctype)}`;
	}
	if (item.type === "Reports" && item.reports) return `/report/${encodeURIComponent(item.reports)}`;
	if (item.link) return item.link;
	if (item.route) return item.route;
	return "/";
}

export function resetMenus() {
	loadPromise = null;
	state.menus = [];
	state.loading = false;
	state.loaded = false;
	state.fromApi = false;
	state.clientCode = null;
}

export function loadMenus(force = false) {
	const code = currentClientCode();
	if (state.loaded && state.fromApi && !force && state.clientCode === code) return Promise.resolve(state.menus);
	if (loadPromise && !force) return loadPromise;

	state.loading = true;
	loadPromise = call("cmenu.api.get_menu", {}, { httpMethod: "GET", skipAuthRedirect: true })
		.then((menus) => {
			const list = Array.isArray(menus) ? menus : menus?.menu || [];
			state.menus = list;
			state.fromApi = list.length > 0;
			state.loaded = true;
			state.clientCode = code;
			return state.menus;
		})
		.catch(() => {
			state.menus = [];
			state.fromApi = false;
			state.loaded = true;
			state.clientCode = code;
			return state.menus;
		})
		.finally(() => {
			state.loading = false;
			loadPromise = null;
		});

	return loadPromise;
}

export { state as menuState };
